import { IconName } from '@storebrand-digital/pretzel/icons';

export enum Segment {
  MAIN = 'main',
  BANK = 'bank',
  INSURANCE = 'insurance',
  OTHER = 'other',
}

export type SegmentId = Segment;

export type ArchiveSegment = {
  id: SegmentId;
  label: string;
  icon: IconName;
  showInKron: boolean;
};

export const archiveSegments: ArchiveSegment[] = [
  {
    id: Segment.MAIN,
    label: 'documentArchive.tab.label',
    icon: 'files',
    showInKron: true,
  },
  {
    id: Segment.BANK,
    label: 'bankArchive.tab.label',
    icon: 'piggy-bank',
    showInKron: true,
  },
  {
    id: Segment.INSURANCE,
    label: 'fakturaArchive.tab.label',
    icon: 'invoice',
    showInKron: false,
  },
  {
    id: Segment.OTHER,
    label: 'other.tab.label',
    icon: 'stack-simple',
    showInKron: false,
  },
];
